import { slices } from "@/constants/sliceNames";
import { errorMessage, successMessage } from "@/store/actions/messages.actions";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios/defaultAxios";
import { HoyaAlert } from "../../../entities/HoyaAlert";
import { serializeQueryParams } from "../../../utils/utils";

const ENDPOINT = "/hoya/monitors/alerts";

/****** Get Monitoring Alerts List ******/

export const requestMonitoringAlerts = createAsyncThunk(
  `${slices.monitoringAlerts}/requestMonitoringAlerts`,
  async (filters, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${ENDPOINT}?${serializeQueryParams(filters)}`);
      const processedData = response.data.data.data.map(HoyaAlert.fromApi);
      return {
        data: processedData,
        records_count: response.data.data.records_count,
      };
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestMonitoringAlertsStatus = {
  [requestMonitoringAlerts.fulfilled]: (state, action) => {
    state.loading = false;
    state.alerts = action.payload.data;
    state.recordsCount = action.payload.records_count;
  },
  [requestMonitoringAlerts.pending]: (state, action) => {
    state.loading = true;
  },
  [requestMonitoringAlerts.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },
};

/****** Get single Monitoring Alert by id ******/

export const requestSingleMonitoringAlert = createAsyncThunk(
  `${slices.monitoringAlerts}/requestSingleMonitoringAlert`,
  async (alertId, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${ENDPOINT}/${alertId}`);
      return HoyaAlert.fromApi(response.data.data);
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestSingleMonitoringAlertStatus = {
  [requestSingleMonitoringAlert.fulfilled]: (state, action) => {
    state.loading = false;
    state.item = action.payload;
  },
  [requestSingleMonitoringAlert.pending]: (state, action) => {
    state.loading = true;
  },
  [requestSingleMonitoringAlert.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },
};

/****** Create Monitoring Alert ******/

export const requestCreateMonitoringAlert = createAsyncThunk(
  `${slices.monitoringAlerts}/requestCreateMonitoringAlert`,
  async (alertData, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(ENDPOINT, alertData);
      dispatch(successMessage(response.data.message));
      console.log(response.data);
      return HoyaAlert.fromApi(response.data.data);
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestCreateMonitoringAlertStatus = {
  [requestCreateMonitoringAlert.fulfilled]: (state, action) => {
    state.loading = false;
    state.alerts.push(action.payload);
  },
  [requestCreateMonitoringAlert.pending]: (state, action) => {
    state.loading = true;
  },
  [requestCreateMonitoringAlert.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },
};

/****** Delete Monitoring Alert by Id ******/

export const requestDeleteMonitoringAlert = createAsyncThunk(
  `${slices.monitoringAlerts}/requestDeleteMonitoringAlert`,
  async (alertId, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.delete(`${ENDPOINT}/${alertId}`);
      dispatch(successMessage(response.data.message));
      return { alertId };
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestDeleteMonitoringAlertStatus = {
  [requestDeleteMonitoringAlert.fulfilled]: (state, action) => {
    state.alerts = state.alerts.filter((alert) => alert.id !== action.payload.alertId);
  },
  [requestDeleteMonitoringAlert.rejected]: (state, action) => {
    state.error = action.payload;
  },
};

/****** Update Monitoring Alert by Id ******/

export const requestUpdateMonitoringAlert = createAsyncThunk(
  `${slices.monitoringAlerts}/requestUpdateMonitoringAlert`,
  async ({ alertId, alertData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.put(`${ENDPOINT}/${alertId}`, alertData);
      dispatch(successMessage(response.data.message));
      return HoyaAlert.fromApi(response.data.data);
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestUpdateMonitoringAlertStatus = {
  [requestUpdateMonitoringAlert.fulfilled]: (state, action) => {
    state.updateLoading = false;
    state.item = action.payload;
  },
  [requestUpdateMonitoringAlert.pending]: (state, action) => {
    state.updateLoading = true;
  },
  [requestUpdateMonitoringAlert.rejected]: (state, action) => {
    state.updateLoading = false;
    state.error = action.payload;
  },
};
